import { adminApi } from './api';

export const getQuestions = async (languageId) => {
    const response = await adminApi.get('/api/admin/ai-review/questions', { params: { languageId } });
    return response.data; // ResponseEntity<List> 반환 구조에 맞춤 (공통 ApiResponse 미적용 시)
};

export const getQuestionDetail = async (questionId) => {
    const response = await adminApi.get(`/api/admin/ai-review/questions/${questionId}`);
    return response.data;
};

export const getPrompts = async (questionId) => {
    const response = await adminApi.get(`/api/admin/ai-review/questions/${questionId}/prompts`);
    return response.data;
};

export const createQuestion = async (data) => {
    const response = await adminApi.post('/api/admin/ai-review/questions', data);
    return response.data;
};

export const updateQuestion = async ({ questionId, ...data }) => {
    const response = await adminApi.put(`/api/admin/ai-review/questions/${questionId}`, data);
    return response.data;
};

export const approveQuestion = async ({ questionId, ...data }) => {
    const response = await adminApi.post(`/api/admin/ai-review/questions/${questionId}/approve`, data);
    return response.data;
};

export const cancelQuestionApproval = async (questionId) => {
    const response = await adminApi.put(`/api/admin/ai-review/questions/${questionId}/cancel-approval`);
    return response.data;
};

export const deleteQuestion = async (questionId) => {
    const response = await adminApi.delete(`/api/admin/ai-review/questions/${questionId}`);
    return response.data;
};